import { websiteBuilderGenerateDefaultHeading } from "../../element/websiteBuilderHeading";
import { websiteBuilderGenerateDefaultParagraph } from "../../element/websiteBuilderParagraph";
import { IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderContent, websiteBuilderGenerateDefaultContent } from "../websiteBuilderContent";
import { websiteBuilderSetTemplateSectionBackgroundImage } from "./websiteBuilderResolveTemplateMedia";

export function websiteBuilderNewsletterTemplate(media: IWebsiteBuilderMediaItem[]): IWebsiteBuilderContent {
  const section = websiteBuilderGenerateDefaultContent();
  const heading = websiteBuilderGenerateDefaultHeading();
  const description = websiteBuilderGenerateDefaultParagraph();

  section.section.background.color = "#000000";
  section.section.background.darken = true;
  section.section.background.darkenPercent = 60;
  websiteBuilderSetTemplateSectionBackgroundImage(section, media, "man-playing-golf-during-daytime");

  section.section.layout.desktop.height = 730;
  section.section.layout.tablet.height = 530;
  section.section.layout.mobile.height = 520;

  heading.element.layout.desktop.position = { x: 200, y: 308 };
  heading.element.layout.tablet.position = { x: 72, y: 205 };
  heading.element.layout.mobile.position = { x: 25, y: 175 };
  heading.element.layout.desktop.dimensions = { width: 600, height: 70 };
  heading.element.layout.tablet.dimensions = { width: 624, height: 60 };
  heading.element.layout.mobile.dimensions = { width: 270, height: 90 };
  heading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "52px",
        tablet: "44px",
        mobile: "36px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, textAlign: "center", lineHeight: "1.2" },
      content: [{
        type: "text",
        text: "Join our email club", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  description.element.layout.desktop.position = { x: 100, y: 388 };
  description.element.layout.tablet.position = { x: 72, y: 275 };
  description.element.layout.mobile.position = { x: 25, y: 275 };
  description.element.layout.desktop.dimensions = { width: 800, height: 35 };
  description.element.layout.tablet.dimensions = { width: 624, height: 50 };
  description.element.layout.mobile.dimensions = { width: 270, height: 70 };
  description.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "22px",
        tablet: "18px",
        mobile: "16px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { textAlign: "center", lineHeight: "1.4" },
      content: [{
        type: "text",
        text: "Join our mailing list and be the first to receive golf updates and tee time deals.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  section.children = [heading, description];

  return section;
}
